import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    DraftGiftVoucherDocument,
    type DraftGiftVoucherMutation,
    type DraftGiftVoucherMutationVariables,
    type MobilityApplicationEntrypointContextDataFragment,
} from '../../../../../api';
import { prepareKYCFieldPayload } from '../../../../../utilities/kycPresets';
import { type GiftVoucherKYCJourneyValues } from './shared';

const useDraftGiftVoucher = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (
            values: GiftVoucherKYCJourneyValues,
            endpoint: MobilityApplicationEntrypointContextDataFragment,
            currentLanguageId: string
        ) => {
            const { data } = await apolloClient.mutate<DraftGiftVoucherMutation, DraftGiftVoucherMutationVariables>({
                mutation: DraftGiftVoucherDocument,
                variables: {
                    setting: {
                        customer: {
                            newLocalCustomer: {
                                fields: prepareKYCFieldPayload(values.customer.fields),
                            },
                        },
                        dealerId: null,
                        mobilityModuleId: endpoint.mobilityApplicationModule.id,
                        moduleId: endpoint.mobilityApplicationModule.giftVoucherModuleId,
                        inventoryId: null,
                        vehicle: {
                            existingSimpleLocalVehicleId: null,
                        },
                        stockId: values.stockId,
                        endpointId: endpoint.id,
                        languageId: currentLanguageId,
                        numberOfBookingReferenceDays: values.numberOfBookingReferenceDays,
                    },
                },
            });

            return data?.draftGiftVoucher;
        },
        [apolloClient]
    );
};

export default useDraftGiftVoucher;
